module.exports = __webpack_public_path__ + "media/images/pic/activities/sakaki-3b32022a0f1effa8c5890fd11385dae9.png";